import { useState } from 'react';

export const ProductImageUseBetween = () => {
    const [hoverProductImageUuid, setHoverProductImageUuid] = useState<string | null>();
    return {
        hoverProductImageUuid,
        setHoverProductImageUuid,
    };
};
